import React from "react";
import { Shield } from "lucide-react";
import {
  ImageFifty,
  ImageFiftyTwo,
  ImageFortyEight,
  ImageFortyNine,
  ImageFortySeven,
} from "../assets/images";

const FourteenTab = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 px-4 sm:px-6 lg:px-8 py-10">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 leading-snug">
              Consent, Privacy
              <br className="hidden sm:block" /> & Compliance
            </h1>
            <div className="relative">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-2xl flex items-center justify-center">
                <Shield className="w-8 h-8 sm:w-10 sm:h-10 text-green-600" />
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 sm:w-8 sm:h-8 bg-pink-400 rounded-full flex items-center justify-center">
                <svg
                  className="w-3 h-3 sm:w-4 sm:h-4 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 font-medium">
            Your data, your rights—secured by global healthcare and digital
            laws.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-16">
          {/* Card 1 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-md hover:shadow-xl transition duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16  rounded-2xl mb-6 mx-auto">
              <img
                src={ImageFortySeven}
                alt="Shield Icon"
                className="w-20 h-20 sm:w-20 sm:h-20"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 text-center mb-1">
              Digital Personal
            </h3>
            <h4 className="text-lg sm:text-xl font-semibold text-gray-700 text-center">
              Data Protection Act (2023)
            </h4>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-md hover:shadow-xl transition duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16  rounded-2xl mb-6 mx-auto">
              <img
                src={ImageFifty}
                alt="Document Icon"
                className="w-20 h-20 sm:w-20 sm:h-20"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 text-center">
              IT Act <br /> (2000)
            </h3>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-md hover:shadow-xl transition duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16  rounded-2xl mb-6 mx-auto">
              <img
                src={ImageFortyNine}
                alt="Stethoscope Icon"
                className="w-20 h-20 sm:w-20 sm:h-20"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 text-center mb-1">
              Telemedicine Practice
            </h3>
            <h4 className="text-lg sm:text-xl font-semibold text-gray-700 text-center">
              Guidelines (2020)
            </h4>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-md hover:shadow-xl transition duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16  rounded-2xl mb-6 mx-auto">
              <img
                src={ImageFifty}
                alt="Security Icon"
                className="w-20 h-20 sm:w-20 sm:h-20"
              />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 text-center mb-1">
              Patient data remains
            </h3>
            <h4 className="text-lg sm:text-xl font-semibold text-gray-700 text-center">
              private and owned by user
            </h4>
          </div>
        </div>

        {/* AI Model Learning Section */}
        <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-md mb-12 max-w-3xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center sm:items-start sm:justify-start text-center sm:text-left gap-4">
            <div className="w-14 h-14 sm:w-16 sm:h-16  rounded-2xl flex items-center justify-center">
              {/* <Lock className="w-7 h-7 sm:w-8 sm:h-8 text-pink-500" /> */}
              <img src={ImageFiftyTwo} alt="privacy" />
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
                AI model learning is opt-in only
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                We request explicit consent before any use of your data.
              </p>
            </div>
          </div>
        </div>

        {/* Privacy Policy Button */}
        <div className="text-center mb-12">
          <button className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-2xl text-base sm:text-lg transition-colors duration-300 shadow-md hover:shadow-xl">
            View Our Privacy Policy
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-12">
        <div className="w-full bg-green-50 py-4 flex flex-wrap items-center justify-center px-4">
          <div className="flex items-center space-x-2 text-green-700 font-medium text-sm sm:text-lg text-center">
            <Shield className="w-5 h-5 sm:w-6 sm:h-6" />
            <span>
              Private • Secure • Clinically Ethical • Legally Compliant
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourteenTab;
